import api from "./api";

/**
 * Paket (Bronze/Silver/Gold) uçları — salon oluştururken paket seçimi ve
 * admin paket/özellik yönetimi için.
 */
export const subscriptionService = {
  list: () => api.get("/subscriptions"),
  get: (id) => api.get(`/subscriptions/${id}`),
  /** Paketlere atanabilen özellik kataloğu (checkbox listesi). */
  features: () => api.get("/subscriptions/features"),
  /** Paketi günceller (ADMIN) — özellik atamalarını kaydetmek için. */
  update: (id, data) => api.put(`/subscriptions/${id}`, data),
  /** Paketin fiyat değişim geçmişi (ADMIN). */
  priceHistory: (id) => api.get(`/subscriptions/${id}/price-history`),
};
